/**
 * Friendship status between viewer and viewed user
 * Used for UI-level permission/visibility logic
 */
export enum FriendshipStatusEnum {
  /** Viewing your own profile */
  SELF = 'SELF',

  /** Users are friends (Neo4j FRIENDS relationship exists) */
  FRIENDS = 'FRIENDS',

  /** Users are not friends */
  NOT_FRIENDS = 'NOT_FRIENDS',

  /** Friend invitation pending (future enhancement) */
  PENDING = 'PENDING',

  /** User is blocked (future enhancement) */
  BLOCKED = 'BLOCKED',
}
